import type { GeneralConfigDto } from "./general-config.dto";

import { api } from "../core/api";

export const getGeneralConfig = async () => {
  const res = await api.get<GeneralConfigDto>("/general_config");
  return res.data;
};
